module.exports = __webpack_public_path__ + "img/send.3ab605cc.svg";